module.exports = __webpack_public_path__ + "img/pass.0fbe4d78.jpg";